<input #file type="file" style="display: none" (change)="onFilesAdded()" accept=".bex" filters=".bex" />

<div class="bmc-upload-bex bz-space--stack-l">
    <div class="bmc-upload-bex-header bz-space--stack-m">
        <span class="bmc-upload-bex-header__title">
            {{ 'DEPLOYMENT.NEED_A_PACKAGE' | translate }}
        </span>
        <div>
            <bzg-button-primary (click)="!isProcessing && uploadPackage()" [disabled]="showLoading || isProcessing || getCurrentStatus">
                {{'DEPLOYMENT.UPLOAD_NEW_PACKAGE' | translate}}
            </bzg-button-primary>
        </div>
    </div>
    <div *ngIf="!currentBex || showLoading || getCurrentStatus">
        <div class="bmc-upload-bex-empty bz-color-border--neutral-400 bz-color-bg--neutral-200 bmc-upload-bex-empty__container bz-space--inset-m"
            *ngIf="!showLoading && !getCurrentStatus">
            <bzg-icon class="bz-space--inline-m" [nameIcon]="'empty-file'" [size]="30"></bzg-icon>
            <div class="bmc-upload-bex-empty__description">
                <strong>{{ 'DEPLOYMENT.BIZAGI_PACKAGE' | translate }}</strong>
                <span class="bz-font-size--body-small">{{ 'DEPLOYMENT.NO_FILE_UPLOADED' | translate }}</span>
            </div>
        </div>
        <div class="bmc-upload-bex-loading bz-color-border--theme-400 bz-color-bg--neutral-200 bmc-upload-bex-empty__container bz-space--inset-m"
            *ngIf="showLoading || getCurrentStatus">
            <bz-loading [theme]="'Beryllium'" [size]="'l'" *ngIf="statusApply && statusApply === 'Begin'"><strong
              class="bz-font-size--body-small">{{'DEPLOYMENT.IMPORTING_PACKAGE' | translate}}</strong>
            </bz-loading>
            <bz-loading [theme]="'Beryllium'" [size]="'l'" *ngIf="statusApply && statusApply === 'LoadingReasons'"><strong
              class="bz-font-size--body-small">{{'DEPLOYMENT.VERIFYING_MAINTENANCE' | translate}}</strong>
            </bz-loading>
            <bz-loading [theme]="'Beryllium'" [size]="'l'" *ngIf="!statusApply && !getCurrentStatus"><strong
              class="bz-font-size--body-small">{{'DEPLOYMENT.UPLOADING_PACKAGE' | translate}}</strong>
            </bz-loading>
            <bz-loading [theme]="'Beryllium'" [size]="'l'" *ngIf="getCurrentStatus"><strong
              class="bz-font-size--body-small">{{'DEPLOYMENT.PREPARING_IMPORT' | translate}}</strong>
            </bz-loading>
        </div>
    </div>

    <div class="bmc-upload-bex-info bz-color-border--neutral-400 bz-color-bg--neutral-200"
        *ngIf="currentBex && !showLoading && !getCurrentStatus">
        <div class="bmc-upload-bex-info__container">
            <bzg-icon class="bz-space--inline-m bz-icon" [nameIcon]="'icon-done-file'" [size]="30"></bzg-icon>
            <div class="bmc-upload-bex-info-description">
                <strong>{{currentBex.BEX.Filename}}</strong>
                <bz-loading [size]="'s'" *ngIf="statusApply && statusApply === 'LoadingReasons'"></bz-loading>
                <div class="bmc-upload-bex-info-description__maintenance" *ngIf="(!statusApply || statusApply !== 'LoadingReasons') && (maintenanceReasons$ | async).length">
                    <bzg-icon [nameIcon]="'icon-warning'" [color]="'warning'" class="bz-space--inline-xs"></bzg-icon>
                    <a (click)="showMaintenanceWindow()"
                        class="bz-font-size--body-small bmc-upload-bex-info-description__maintenance-text">{{ 'DEPLOYMENT.MAINTENANCE_WINDOW_GENERATE' | translate }}</a>
                </div>
            </div>
            <div class="bmc-upload-bex-info-user">
                <div class="bmc-upload-bex-info-user__container bz-space--inline-m">
                    <strong class="bz-font-size--body-small">{{'DEPLOYMENT.UPLOADED_BY' | translate}}
                        {{currentBex.BEX.Username}}</strong>
                    <span class="bz-font-size--body-small">{{currentBex.BEX.ImportTime | showDateFormat: 1}}</span>
                </div>

                <bzg-button-secondary class="bz-space--inline-s" [size]="'s'" [disabled]="isProcessing"
                    (click)="!isProcessing && cancel()">
                    {{ 'GLOBAL.CANCEL' | translate }}</bzg-button-secondary>

                <bzg-button-secondary class="bz-space--inline-s" [size]="'s'" [icon]="'icon-view'" [disabled]="isProcessing"
                    (click)="!isProcessing && openPackageVisualizer()">
                    {{ 'DEPLOYMENT.VIEW_CONTENT' | translate }}</bzg-button-secondary>
                <bzg-button-primary [size]="'s'" [active]="!isProcessing" [disabled]="isProcessing" (click)="!isProcessing && importPackage()">
                    {{ 'DEPLOYMENT.IMPORT' | translate }}</bzg-button-primary>
            </div>
        </div>
    </div>
</div>
